import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

export default makeStyles((theme) => ({
  root: {
    width: 480,
    padding: theme.spacing(3),
  },
  header: {
    display: "flex",
    flexDirection: "column",
  },
  title: {
    fontWeight: 500,
  },
  subtitle: {
    color: grey[600],
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  description: {
    color: grey[700],
    fontSize: 14,
    marginTop: theme.spacing(1),
  },
  field: {
    marginTop: theme.spacing(3),
  },
}));
